import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { familyService } from '../services/familyService'
import { Family } from '../types/patientRelationship'
import './Families.css'

export function Families() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const { data: families, isLoading, error } = useQuery({
    queryKey: ['families'],
    queryFn: () => familyService.getAll(),
  })

  const deleteMutation = useMutation({
    mutationFn: (id: string) => familyService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['families'] })
    },
  })

  const handleDelete = async (family: Family, e: React.MouseEvent) => {
    e.stopPropagation()
    if (
      window.confirm(
        `Are you sure you want to delete "${family.name}"? This will unlink all family members but will not delete the patients.`
      )
    ) {
      try {
        await deleteMutation.mutateAsync(family.id)
      } catch (error) {
        alert('Failed to delete family')
      }
    }
  }

  if (isLoading) return <div className="loading">Loading families...</div>
  if (error) return <div className="error">Error loading families</div>

  return (
    <div className="families-page">
      <div className="families-header">
        <h1>Families</h1>
        <button
          className="btn-primary"
          onClick={() => navigate('/families/new')}
        >
          Create New Family
        </button>
      </div>

      {!families || families.length === 0 ? (
        <div className="empty-state">
          <p>No families found. Create a new family to link patients together.</p>
          <button
            className="btn-primary"
            onClick={() => navigate('/families/new')}
          >
            Create Family
          </button>
        </div>
      ) : (
        <div className="families-grid">
          {families.map((family) => (
            <div
              key={family.id}
              className="family-card"
              onClick={() => navigate(`/families/${family.id}`)}
            >
              <div className="family-card-header">
                <h2>{family.name}</h2>
                <div className="family-card-actions">
                  <button
                    className="btn-link"
                    onClick={(e) => {
                      e.stopPropagation()
                      navigate(`/families/${family.id}/edit`)
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="btn-archive"
                    onClick={(e) => handleDelete(family, e)}
                    disabled={deleteMutation.isPending}
                  >
                    Delete
                  </button>
                </div>
              </div>
              {family.description && (
                <p className="family-description">{family.description}</p>
              )}
              <div className="family-info">
                <div className="info-item">
                  <label>Members</label>
                  <p>{family.memberIds.length} {family.memberIds.length === 1 ? 'member' : 'members'}</p>
                </div>
                {family.primaryContactId && (
                  <div className="info-item">
                    <label>Primary Contact</label>
                    <p>Set</p>
                  </div>
                )}
                <div className="info-item">
                  <label>Status</label>
                  <p>
                    <span className={`badge ${family.isActive ? 'active' : 'inactive'}`}>
                      {family.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}



































